import React, { useEffect, useMemo, useState } from "react";
import { Field, connect } from "formik";
import { Fields } from "../../../uicomponents";

function TaskMessageForm({ isSubmitting, formik, leadId }) {
  const [selectRole, setSelectRole] = useState(null);

  function getOrgId(value) {
    if (value === null || value === undefined) return null;
    if (typeof value === "object") {
      if ("id" in value && value.id !== null && value.id !== undefined)
        return value.id;
      if ("value" in value && value.value !== null && value.value !== undefined)
        return value.value;
      return null;
    }
    return value;
  }

  let formValues = formik && formik.values ? formik.values : {};
  let orgId = getOrgId(formValues.organization_ids);
  let orgKey = orgId === null || orgId === undefined ? "none" : String(orgId);

  useEffect(
    function() {
      if (formik && formik.setFieldValue)
        formik.setFieldValue("user_id", null, false);
      if (formik && formik.setFieldTouched)
        formik.setFieldTouched("user_id", false, false);
      if (formik && formik.setFieldError)
        formik.setFieldError("user_id", undefined);
    },
    [selectRole, orgKey],
  );

  const userParams = useMemo(
    function() {
      return function(search) {
        let extra = { name: search };
        if (selectRole) extra.role = selectRole;
        if (orgId !== null && orgId !== undefined)
          extra.organization_id = orgId;
        return { extra: extra };
      };
    },
    [selectRole, orgKey],
  );

  return (
    <div className="form !justify-start !flex-wrap">
      {/* <div
        className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-3/12 max-w-[25%]"
        style={{ paddingRight: 0 }}
      >
        <Field
          component={Fields.AsyncSelectS1}
          name="organization_ids"
          isSearchable={true}
          isClearable={true}
          placeholder="Выберите филиал"
          menuPlacement="top"
          size="small"
          optionLabel="name"
          optionValue="id"
          loadOptionsUrl="/branches"
          loadOptionsParams={function(search) {
            return { extra: { name: search } };
          }}
        />
      </div> */}

      {/* <div
        className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-3/12 max-w-[25%]"
        style={{ paddingRight: 0 }}
      >
        <Fields.SelectD1
          placeholder={"Выберите тип"}
          size={"small"}
          value={selectRole}
          className={"mb-0 multi-no-wrap"}
          menuPlacement="top"
          isClearable={true}
          options={[
            { value: "operator", name: "Оператор" },
            { value: "installer", name: "Установщик" },
            { value: "sales", name: "Продавец" },
            { value: "moderator", name: "Модератор" },
            { value: "copywriter", name: "Копирайтер" },
          ]}
          onChangeHandle={function(option) {
            setSelectRole(option ? option.value : null);
          }}
        />
      </div> */}

      <div
        className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-3/12 max-w-[25%]"
        style={{ paddingRight: 0 }}
      >
        <Field
          key={(selectRole ? selectRole : "none") + "-" + orgKey}
          component={Fields.AsyncSelectS1}
          isClearable
          isSearchable
          name="user_id"
          placeholder="Сотрудники"
          menuPlacement="top"
          label={null}
          size="small"
          optionValue="id"
          optionLabel="name"
          // loadOptionsUrl="/user"
          loadOptionsUrl={`/employee/leads/${leadId}/users`}
          loadOptionsParams={userParams}
          loadOptionsKey={(data) => (Array.isArray(data) ? data : data.data)}
        />
      </div>
      <div
        className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-3/12 max-w-[25%]"
        style={{ paddingRight: 0 }}
      >
        <Field
          component={Fields.AsyncSelectS1}
          isClearable
          isSearchable
          name="service_id"
          optionValue="id"
          placeholder="Сервис"
          label={null}
          size="small"
          optionLabel="name"
          loadOptionsUrl="/services"
          loadOptionsParams={function(search) {
            return { extra: { name: search } };
          }}
          menuPlacement="top"
        />
      </div>
      <div
        className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-3/12 max-w-[25%] p-0"
        style={{ paddingRight: 0 }}
      >
        <Field
          component={Fields.InputS1}
          name="name"
          type="text"
          placeholder="Введите задачу"
          label={null}
          className="flex-grow"
          size="small"
        />
      </div>

      <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
        <Field
          component={Fields.NewDatePicker}
          name="scheduled_time"
          placeholder="Дедлайн"
          format="dd.MM.yyyy HH:mm"
          showTimeSelect={true}
          label={null}
          className="date-picker"
        />
      </div>

      <button type="submit" disabled={isSubmitting} className="send-button">
        Создать
      </button>
    </div>
  );
}

export default connect(TaskMessageForm);
